<h1 *ngIf="!alliances">Loading...</h1>
<section
  *ngIf="alliances"
  class="container flex justify-center w-full px-2 mx-auto"
>
  <table class="table border-separate">
    <thead class="">
      <tr class="">
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">Id</th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Name
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          President
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Members
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let alliance of alliances">
        <td class="px-2 text-right border border-gray-800 border-solid">
          <a [routerLink]="['/alliance', alliance.id]">{{ alliance.id }}</a>
        </td>
        <td class="px-2 border border-gray-800 border-solid">
          <a
            [routerLink]="['/alliance', alliance.id]"
            [innerHTML]="alliance.name | safeHtml"
          >
          </a>
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          <a [routerLink]="['/player', alliance.president.id]">
            <span [innerHTML]="alliance.president.name | safeHtml"> </span>
            ({{ alliance.president.id }})
          </a>
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ alliance.members }}
        </td>
      </tr>
    </tbody>
  </table>
</section>
